<template>
<v-container>
  <v-row>
    <v-col><AvatarWithBadge :user="user" :size="90" /></v-col>
  </v-row>
  <v-row class="stylized-font">
    <v-col>
      <v-img :src="require('@/assets/firework1.svg')" width="200px" style="position: absolute;" />
      <h2 style="max-width: 500px; margin: 0px auto;">
        <p class="mb-0">{{ $t('becomeACreator.lastStepsContent.congratulations') }}</p>
        <p>{{ $t('becomeACreator.lastStepsContent.youreOnYourWay') }}</p>
      </h2>
    </v-col>
  </v-row>
<v-row class="stylized-font">
  <v-col>
    <h1>
        <span class="text-uppercase">
          {{ $t("becomeACreator.lastStepsContent.clickToCreate") }}
        </span>
        <div style="display: inline; padding-right: 10px; width: 1px; height: 1px;" id="arrow-origin">
        </div>
        <br />
        {{ $t('becomeACreator.lastStepsContent.clickToCreateNow')}}
    </h1>
  </v-col>
</v-row>
<v-row class="stylized-font">
  <v-col>
    <v-img :src="require('@/assets/firework2.svg')" width="200px" style="position: absolute; right: 50px" />
    <span class="font-weight-medium" style="font-size: 1.4em">{{ $t('becomeACreator.lastStepsContent.firstLesson')}}</span>
  </v-col>
</v-row>
<v-row>
  <v-col>
    <p class="mb-3">
      <i18n path="creator.notSureWhereToStart">
        <router-link :to="{name: 'creator-resources'}">{{
          $t("creator.notSureWhereToStart0")
        }}</router-link>
      </i18n>
    </p>
  </v-col>
</v-row>
    <v-row class="mt-15">
      <v-col>
        <v-row>
          <v-col class="stylized-font text-left" style="font-size: 1.5em"
            >{{ $t("becomeACreator.lastStepsContent.housekeeping") }}:</v-col
          >
        </v-row>
        <v-row>
          <v-col
            ><AltButton :to="{ name: 'banking' }">{{
              $t("becomeACreator.lastStepsContent.addBankingInfo")
            }}</AltButton></v-col
          >
        </v-row>
        <v-row v-if="user && user.isVerified == false">
          <v-col>
            <AltButton :to="{name: 'verify-email'}">{{ $t('register.verification.verifyYourEmail') }}</AltButton>
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <v-row>
          <v-col class="stylized-font">{{
            $t("becomeACreator.lastStepsContent.doThatLater")
          }}</v-col>
        </v-row>
        <v-row>
          <v-col
            ><v-btn class="mt-4" color="primary" to="/creator-dashboard">{{
              $t("becomeACreator.lastStepsContent.goToDashboard")
            }}</v-btn></v-col
          >
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import AvatarWithBadge from "@/components/User/AvatarWithBadge";
import hasLoggedInUser from "@/mixins/hasLoggedInUser";
import LeaderLine from "leader-line-vue";
import AltButton from "@/components/Reusable/AltButton.vue";
export default {
  mixins: [hasLoggedInUser],
  components: {
    AvatarWithBadge,
    AltButton,
  },
  data() {
    return {
      line: null,
    };
  },
  mounted() {
    var vm = this;
    setTimeout(function () {
      const origin = document.getElementById("arrow-origin");
      const destination = document.getElementById("create-story-button");
      if (origin && destination) {
        vm.line = LeaderLine.setLine(origin, destination, { hide: true });
        vm.line.setOptions({
          startSocket: "bottom",
          endSocket: "bottom",
          startSocketGravity: [240, 40],
        });
        vm.line.color = "#0F4E75";
        vm.line.show("draw", {
          animOptions: { duration: 500, timing: [0.58, 0, 0.42, 1] },
        });
      }
    }, 200);
  },
  beforeRouteLeave(to, from, next) {
    next();
    if (this.line) {
      this.line?.remove();
      this.line = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.stylized-font {
  font-family: DarkerGrotesque;
  font-size: 21px;
  line-height: 150%;
}
</style>